import { createSelector } from "reselect";
import { woundsSectionSelector } from "../wounds_section_selector";

export const selectedProgressFilterSelector = createSelector(
  woundsSectionSelector,
  woundsSection => {
    return woundsSection.selectedProgressFilter;
  }
);
